import { render, staticRenderFns } from "./BumperBox.vue?vue&type=template&id=17781b28&scoped=true&"
import script from "./BumperBox.vue?vue&type=script&lang=js&"
export * from "./BumperBox.vue?vue&type=script&lang=js&"
import style0 from "./BumperBox.vue?vue&type=style&index=0&id=17781b28&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17781b28",
  null
  
)

export default component.exports